import React, {useLayoutEffect, useRef} from 'react';
import styled from 'styled-components';
import {useProductName} from 'components/customer/RoomPlanner/helper/useProductName';
import {Breadcrumbs} from 'components/customer/Product';
import {useSearchParams} from 'react-router-dom';
import {mobileLandscape, portraitDevices} from 'shared/Breakpoints';

const STICKY_OFFSET_PROPERTY = '--product-wizard-sticky-offset';

export const Header = () => {
    const {name: productName, productNumber} = useProductName();
    const [searchParams] = useSearchParams();
    const headerRef = useRef<HTMLDivElement>(null);
    const showBreadcrumbs =
        searchParams.has('product') ||
        !!searchParams.get('placeholderEdit') ||
        !!searchParams.get('placeholderFace');

    useLayoutEffect(() => {
        const headerEl = headerRef.current;

        if (!headerEl) return;

        const updateStickyOffset = () => {
            document.documentElement.style.setProperty(
                STICKY_OFFSET_PROPERTY,
                `${headerEl.offsetHeight + 1}px`
            );
        };

        updateStickyOffset();

        const resizeObserver = new ResizeObserver(updateStickyOffset);
        resizeObserver.observe(headerEl);

        return () => {
            resizeObserver.disconnect();
            document.documentElement.style.removeProperty(
                STICKY_OFFSET_PROPERTY
            );
        };
    }, []);

    return (
        <HeaderComponent ref={headerRef}>
            <ControlsContainer>
                {showBreadcrumbs ? (
                    <ProductName>
                        <div className="search-info">
                            <Breadcrumbs hideLast={true} />
                        </div>
                        <strong>
                            {productNumber ? `(${productNumber}) ` : ''}
                            {productName}
                        </strong>
                    </ProductName>
                ) : null}
            </ControlsContainer>
        </HeaderComponent>
    );
};

export const HeaderComponent = styled.div`
    position: sticky;
    top: 0;
    z-index: 99;
    margin-left: -15px;
    margin-right: -15px;
    padding: 8px 15px;
    background: white;
`;

export const ProductName = styled.div`
    ${({theme}) => {
        return `
            word-break: break-word;
            text-align: left;

            > strong {
                color: ${theme.colors.primary?.main};
                font-size: 0.85em;
            }
        `;
    }}
`;

export const ControlsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 5px;
    align-items: flex-start;
    background-color: white;

    ${portraitDevices`
        align-items: baseline;
        justify-content: space-between;
    `}

    ${mobileLandscape`
        align-items: baseline;
        justify-content: space-between;
    `}
`;

export const ButtonContainer = styled.div`
    cursor: pointer;

    > img {
        width: 20px;
        border-radius: 20px;
        border: 1px solid #6d6e71;
    }
`;
